export * from './mapResponseToUser'
export * from './mapUserToInput'
export * from './checkRole'

export const findById = <T extends { id: string }>(list: Array<T>, id: string): T | undefined =>
  list.find(element => element.id === id)
